/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CountryCode } from '../enums/country-code';
import { Role } from '../enums/role';
import { CandidateEntity } from './candidate-entity';
import { ContactEntity } from './contact-entity';
import { UserSettingEntity } from './user-setting-entity';
export class UserEntity extends Entity {
  bullhornId: string | null = null;
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  contact: ContactEntity | null = null;
  contactId: string | null = null;
  createdAt: string | null = null;
  email: string | null = null;
  firstLoginAt: string | null = null;
  firstName: string | null = null;
  fullName: string | null = null;
  homeOffice: string | null = null;
  id: string = '';
  integrationId: string | null = null;
  isActive: boolean | null = null;
  lastLoginAt: string | null = null;
  lastName: string | null = null;
  notificationsPhoneNumber: string | null = null;
  notificationsPhoneNumberCountry: CountryCode | null = null;
  notificationsPhoneNumberCountryCode: string | null = null;
  organizationId: string | null = null;
  registeredForMfa: boolean | null = null;
  roles: Role[] | null = null;
  salesforceId: string | null = null;
  settings: UserSettingEntity[] = [];
  termsAndConditionsAcceptedAt: string | null = null;
  updatedAt: string | null = null;
  created_at?: string | null = null;
  hasAcceptedTermsAndConditions?: boolean | null = null;
  updated_at?: string | null = null;
  userId?: string | null = null;
  static override key = 'User';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      contact: ContactEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'User' in input
    ) {
      const { User: wrapped, ...rest } = input as {
        User: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}